import React, { Fragment } from 'react'


const SingleProduct = ({ order, orderID, setOrderID, setOrderData }) => {





    const handleClassName = (orderStatus) => {


        if (orderStatus === "ORDERED") return "text-green-600 bg-green-100";
        if (orderStatus === "REVIEWED") return "text-pink-500 bg-pink-100";
        if (orderStatus === "DELIVERED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "SUSPENDED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "ON_HOLD") return "text-blue-500 bg-blue-100";
        if (orderStatus === "REFUNDED") return "text-green-600 bg-green-100";
        if (orderStatus === "COMMISSIONED") return "text-slate-500 bg-slate-100";
        if (orderStatus === "COMPLETED") return "text-purple-500 bg-purple-100";
        if (orderStatus === "CANCELLED") return "text-[#B04926] bg-[#b0482637]";
        if (orderStatus === "REVIEW_DELETED") return "text-red-500 bg-red-100";
        if (orderStatus === "SYSTEM_CANCELLED") return "text-red-500 bg-red-100";

    }







    return (
        <Fragment>
            <div className="grid grid-cols-[0.7fr_5fr_1fr]   gap-[1vmax] items-center  p-[0.8vmax_0.5vmax] rounded-xl hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                    setOrderID(prev => prev === order?.id ? null : order?.id)
                    setOrderData(prev => prev?.id === order?.id ? {} : order)
                }}
            >
                <div className="aspect-square rounded-full grid place-items-center overflow-hidden bg-gray-200">
                    <img src={order?.custom_image} alt="" />
                </div>
                <div className="">
                    <h3 className='text-[1vmax] font-bold flex items-center' >
                        Order ID : {order?.id}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span className={`text-[0.7vmax] font-[500] text-gray-500  inline-block  p-[0.3vmax_0.5vmax] rounded-full
                            ${handleClassName(order?.status)}`} >
                                {order?.status?.replaceAll("_", " ").toUpperCase()}
                            </span>
                    </h3>
                    <p className='text-[0.8vmax] mt-[0.1vmax] text-gray-500' >Product ID : {order?.id}</p>
                </div>
                <div className={`text-right ${order === order?.id ? "opacity-100" : "opacity-0"} pr-[1vmax]`} >
                    <i className="fa-solid fa-check text-blue-500"></i>
                </div>
            </div>

        </Fragment>
    )
}

export default SingleProduct
